import { useStateStore } from "@/context/stateStore";

export default async function VerifyUser({ userEmail, urlToUse }: { userEmail: string; urlToUse: string; }) {

    if (!urlToUse || urlToUse.trim() === '') {
        useStateStore.getState().setUserVerified(false);
        return;
    }

    try {

        if (!userEmail || userEmail.trim() === '') {
            useStateStore.getState().setUserVerified(false);
            return;
        }
        const res = await fetch(`${urlToUse}/api/user/getUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userEmail }),
        });
        if (!res) {
            useStateStore.getState().setUserVerified(false);
            return;
        }
        const data = await res.json()
        if (!data) {
            useStateStore.getState().setUserVerified(false);
            return;
        }
        if (data.status !== 200) {
            useStateStore.getState().setUserVerified(false);
            return;
        }
        useStateStore.getState().setUserVerified(true);
        return;

    } catch (error) {
        console.error("Error verifying user:", error);
    }
}
